// import React from "react";
// import E3Content from "../Components/E3Content";

// const E3TakeOver = () => {
//   return <E3Content />;
// };

// export default E3TakeOver;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import E3Content from "../Components/E3Content";

const E3TakeOver = () => {
  const seoData = getSEOData("/e3-takeover");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <E3Content />
    </>
  );
};

export default E3TakeOver;